import { NgModule } from '@angular/core';
import { IgismaplibUploadFileComponent } from './igismaplib-upload-file.component';
import { UploadFileLibComponent } from './upload-file-lib/upload-file-lib.component';
import { AppMaterialModule } from './app-material-module/app-material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { NotificationMessageComponent } from './notification-message/notification-message.component';


 
@NgModule({
  declarations: [
    IgismaplibUploadFileComponent, 
    UploadFileLibComponent,
    NotificationMessageComponent],
  imports: [

    AppMaterialModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    HttpClientModule, 


  ],
  exports: [IgismaplibUploadFileComponent],
  entryComponents:[NotificationMessageComponent]
})
export class IgismaplibUploadFileModule { }
